/**
 * Needed for {{Find closest}} custom javascript variable in Google Tag Manager
 *
 * @see https://www.algolia.com/doc/guides/getting-insights-and-analytics/connectors/google-tag-manager/#variables
 */

if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.matchesSelector ||
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}
